module.exports = __webpack_public_path__ + "img/smart-scan-2.6dbe4f36.png";